var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgMicrosoft = function SvgMicrosoft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#microsoft_svg__clip0_1842_4282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.553 9.553H1V1h8.553v8.553z",
    fill: "#F1511B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.997 9.553h-8.553V1h8.553v8.553z",
    fill: "#80CC28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.553 19H1v-8.553h8.553V19z",
    fill: "#00ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.997 19h-8.553v-8.553h8.553V19z",
    fill: "#FBBC09"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "microsoft_svg__clip0_1842_4282"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 1)",
    d: "M0 0h17.997v18H0z"
  })))));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE4NDJfNDI4MikiPgo8cGF0aCBkPSJNOS41NTI4OCA5LjU1Mjg4SDFWMUg5LjU1Mjg4VjkuNTUyODhaIiBmaWxsPSIjRjE1MTFCIi8+CjxwYXRoIGQ9Ik0xOC45OTcyIDkuNTUyODhIMTAuNDQzNlYxSDE4Ljk5NjVWOS41NTI4OEgxOC45OTcyWiIgZmlsbD0iIzgwQ0MyOCIvPgo8cGF0aCBkPSJNOS41NTI4OCAxOUgxVjEwLjQ0NzFIOS41NTI4OFYxOVoiIGZpbGw9IiMwMEFERUYiLz4KPHBhdGggZD0iTTE4Ljk5NzIgMTlIMTAuNDQzNlYxMC40NDcxSDE4Ljk5NjVWMTlIMTguOTk3MloiIGZpbGw9IiNGQkJDMDkiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xODQyXzQyODIiPgo8cmVjdCB3aWR0aD0iMTcuOTk3MSIgaGVpZ2h0PSIxOCIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgMicrosoft as ReactComponent };